export enum SketchPageType {
  InspectionForm = 'inspection_form',
  BlankRows = 'blank_rows'
}

export interface PageSketchStroke {
  id: string;
  tool: 'pen' | 'highlighter' | 'eraser';
  color: string;
  width: number;
  points: { x: number; y: number }[];
  timestamp: number;
}

export interface PageSketchData {
  version: 1;
  strokes: PageSketchStroke[];
  canvasWidth?: number;
  canvasHeight?: number;
}

export interface CreateSketchDto {
  orderId: number;
  pageType: SketchPageType;
  title?: string;
  rowsCount?: number;
}

export interface UpdateSketchDto {
  pageSketchData?: PageSketchData;
  title?: string;
}

export interface InspectionSketchDto {
  id?: number;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  orderId: number;
  pageType: SketchPageType;
  title?: string;
  rowsCount?: number;
  pageSketchData?: PageSketchData;
}
